import _slicedToArray from '@babel/runtime/helpers/slicedToArray';

/**
 * Resolves a given path to a chakra CSS variable
 *
 * @example resolveTokenVarRef(theme, 'colors.blue.400')
 * @see https://github.com/chakra-ui/chakra-ui/blob/baa6fee280530137548f961db5cb308100bc3920/packages/styled-system/src/css.ts#L20-L31
 */
var resolveTokenVarRef = function resolveTokenVarRef(theme, path) {
  var _ref, _getVar2;
  if (path == null) return null;
  var getVar = function getVar(val) {
    var _theme$__cssMap, _theme$__cssMap$val;
    return (_theme$__cssMap = theme.__cssMap) === null || _theme$__cssMap === void 0 ? void 0 : (_theme$__cssMap$val = _theme$__cssMap[val]) === null || _theme$__cssMap$val === void 0 ? void 0 : _theme$__cssMap$val.varRef;
  };
  var getpath = function getpath(val) {
    var _getVar;
    return (_getVar = getVar(val)) !== null && _getVar !== void 0 ? _getVar : val;
  };
  var pathSplit = path.split(',').map(function (v) {
    return v.trim();
  });
  var _pathSplit = _slicedToArray(pathSplit, 2),
    tokenpath = _pathSplit[0],
    fallbackpath = _pathSplit[1];
  path = (_ref = (_getVar2 = getVar(tokenpath)) !== null && _getVar2 !== void 0 ? _getVar2 : getpath(fallbackpath)) !== null && _ref !== void 0 ? _ref : null;
  return path;
};
export { resolveTokenVarRef };